
  /* PostHog capture — safe no-op when analytics is disabled. Shared by every
     hook below so a missing/blocked PostHog never breaks the PDP. */
  function jcTrack(name, props) { try { if (window.posthog && posthog.capture) posthog.capture(name, props || {}); } catch (e) {} }

  // gallery
  var gMain = document.getElementById('gMain');
  var thumbs = document.querySelectorAll('.thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      thumbs.forEach(function(x){ x.classList.remove('sel'); });
      t.classList.add('sel');
      t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      gMain.src = t.dataset.full;
      gMain.alt = t.dataset.alt || "Knuffel Hüft- & Gelenk-Kausnacks";
      gMain.style.objectFit = t.classList.contains('contain') ? 'contain' : 'cover';
      gMain.style.width = t.classList.contains('contain') ? '82%' : '100%';
      gMain.style.height = t.classList.contains('contain') ? '82%' : '100%';
    });
  });

  /* gallery arrows: reuse the thumb click so the selected thumb, image fit and
     any future gallery state stay in one place rather than diverging. */
  (function () {
    var prev = document.getElementById('gPrev');
    var next = document.getElementById('gNext');
    if (!prev || !next || !thumbs.length) return;
    function step(dir) {
      var list = [].slice.call(thumbs);
      var i = list.findIndex(function (t) { return t.classList.contains('sel'); });
      if (i < 0) i = 0;
      var n = (i + dir + list.length) % list.length;   // wraps both ways
      list[n].click();
    }
    prev.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); step(1); });
  })();

  /* thumbnail scroll hint: right-edge arrow that scrolls the strip and hides at the end */
  (function () {
    var wrap = document.querySelector('.thumbs-wrap');
    var strip = document.querySelector('.thumbs');
    var hint = document.getElementById('thumbsHint');
    if (!wrap || !strip) return;
    function update() {
      var scrollable = strip.scrollWidth - strip.clientWidth;
      wrap.classList.toggle('no-scroll', scrollable <= 2);
      wrap.classList.toggle('at-end', strip.scrollLeft >= scrollable - 2);
    }
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (hint) hint.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.7, behavior: 'smooth' }); });
    update();
  })();


  // weight chips
  var chips = document.querySelectorAll('#weights .chip');
  chips.forEach(function(c){
    c.addEventListener('click', function(){
      chips.forEach(function(x){ x.classList.remove('sel'); });
      c.classList.add('sel');
    });
  });

  // plan selection -> CTA + value stack + sticky bar

  // sticky ATC after scrolling past the buy box
  var bar = document.getElementById('stickybar');
  var hero = document.getElementById('buy');
  if ('IntersectionObserver' in window && bar && hero) {
    var stickySeen = false;
    new IntersectionObserver(function(entries){
      var e = entries[0];
      var showBar = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('show', showBar);
      if (showBar && !stickySeen) { stickySeen = true; jcTrack('sticky_cta_view', {}); }
    }, {threshold: 0}).observe(hero);
  }



/* ---- Paket-Popup (PetLab-style bottom sheet) -------------------------------
   Pure UI here: open/close, selection state, and the price figures it is told
   to show. It owns NO pricing logic — Shopify selling-plan allocations drive the
   numbers, so the sheet can never disagree with checkout.
--------------------------------------------------------------------------- */
(function () {
  var sheet = document.getElementById("plSheet");
  var back  = document.getElementById("plBackdrop");
  var open  = document.getElementById("plOpen");
  if (!sheet || !back || !open) return;

  // Scroll lock. `body { overflow: hidden }` alone is not enough — iOS Safari
  // ignores it and keeps scrolling the page behind the sheet. Pinning the body with
  // position:fixed at its current offset is the only reliable way; we restore the
  // exact scroll position on close so the page does not jump.
  var lockedAt = 0;
  function lockScroll() {
    lockedAt = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.classList.add("pl-lock");
    b.style.position = "fixed";
    b.style.top = -lockedAt + "px";
    b.style.left = "0";
    b.style.right = "0";
    b.style.width = "100%";
  }
  function unlockScroll() {
    var b = document.body;
    b.classList.remove("pl-lock");
    b.style.position = "";
    b.style.top = "";
    b.style.left = "";
    b.style.right = "";
    b.style.width = "";
    window.scrollTo(0, lockedAt);
  }

  function show() {
    sheet.hidden = false; back.hidden = false;
    lockScroll();
    requestAnimationFrame(function () {
      sheet.classList.add("open"); back.classList.add("open");
    });
  }
  function abandonIfOpen() {
    // Opened the buy sheet but left without adding to cart — a hesitation signal.
    // _plAdded is set by the add-to-cart handler; a successful add navigates away
    // and never counts as an abandon.
    if (sheet._plOpened && !sheet._plAdded) {
      jcTrack("sheet_abandon", {
        sheet_config: sheet.dataset.config || null,
        plan_switch_count: sheet._plSwitches || 0,
        dwell_ms: sheet._plOpenedAt ? Date.now() - sheet._plOpenedAt : null
      });
    }
    sheet._plOpened = false;
  }
  function hide() {
    abandonIfOpen();
    sheet.classList.remove("open"); back.classList.remove("open");
    unlockScroll();
    setTimeout(function () { sheet.hidden = true; back.hidden = true; }, 300);
  }
  window.addEventListener("pagehide", abandonIfOpen);
  // the backdrop must not scroll anything at all
  back.addEventListener("touchmove", function (e) { e.preventDefault(); }, { passive: false });
  back.addEventListener("click", hide);
  var handle = document.getElementById("plHandle");
  if (handle) handle.addEventListener("click", hide);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !sheet.hidden) hide();
  });
  sheet.plHide = hide;

  function pick(list, el) {
    list.forEach(function (x) {
      x.classList.remove("sel");
      // Only elements wired as ARIA radios below carry these; setting them on
      // plain buttons (.pl-size / .pl-tog) would be wrong, so gate on role.
      if (x.getAttribute("role") === "radio") {
        x.setAttribute("aria-checked", "false");
        x.tabIndex = -1;
      }
    });
    el.classList.add("sel");
    if (el.getAttribute("role") === "radio") {
      el.setAttribute("aria-checked", "true");
      el.tabIndex = 0;
    }
  }
  var sizes = [].slice.call(sheet.querySelectorAll(".pl-size"));
  var togs  = [].slice.call(sheet.querySelectorAll(".pl-tog"));
  var planGroup = document.getElementById("plPlans");
  function plans() { return [].slice.call(sheet.querySelectorAll(".pl-plan")); }

  // The plan cards are <label>s with no control inside, so nothing focused them
  // and 1 Dose / 3 Dosen was unreachable by keyboard — the sheet could be opened
  // but the package never changed. Promote them to a proper radiogroup with a
  // roving tabindex rather than adding real inputs, which would double-fire the
  // click handler below (label click -> synthetic input click).
  function syncPlanA11y() {
    var list = plans();
    if (!planGroup || !list.length) return;
    planGroup.setAttribute("role", "radiogroup");
    if (!planGroup.getAttribute("aria-label")) planGroup.setAttribute("aria-label", "Paket wählen");
    if (!list.some(function (p) { return p.classList.contains("sel"); })) list[0].classList.add("sel");
    list.forEach(function (p) {
      p.setAttribute("role", "radio");
      var on = p.classList.contains("sel");
      p.setAttribute("aria-checked", on ? "true" : "false");
      p.tabIndex = on ? 0 : -1;
    });
  }
  syncPlanA11y();
  sheet.plSyncPlans = syncPlanA11y;

  function emit() { sheet.dispatchEvent(new CustomEvent("pl:change")); }

  sizes.forEach(function (b) {
    b.addEventListener("click", function () {
      sheet.dataset.variantSelection = "user";
      pick(sizes, b); emit();
      jcTrack("weight_selected", { weight: b.getAttribute("data-key") || (b.textContent || "").trim(), sheet_config: sheet.dataset.config || null });
    });
  });
  togs.forEach(function (b) {
    b.addEventListener("click", function () {
      pick(togs, b);
      sheet.setAttribute("data-mode", b.getAttribute("data-mode"));
      emit();
      sheet._plSwitches = (sheet._plSwitches || 0) + 1;
      jcTrack("mode_toggle", { to: b.getAttribute("data-mode"), sheet_config: sheet.dataset.config || null });
    });
  });
  if (planGroup) {
    planGroup.addEventListener("click", function (e) {
      var p = e.target && e.target.closest ? e.target.closest(".pl-plan") : null;
      if (!p || !planGroup.contains(p)) return;
      pick(plans(), p); emit();
      sheet._plSwitches = (sheet._plSwitches || 0) + 1;
      jcTrack("plan_selected", { quantity: Number(p.getAttribute("data-qty")) || 1, selling_plan: p.getAttribute("data-plan-id") || null, mode: sheet.getAttribute("data-mode"), sheet_config: sheet.dataset.config || null });
    });
    planGroup.addEventListener("keydown", function (e) {
      var p = e.target && e.target.closest ? e.target.closest(".pl-plan") : null;
      if (!p) return;
      var k = e.key;
      if (k === " " || k === "Enter") { e.preventDefault(); p.click(); return; }
      var fwd = k === "ArrowDown" || k === "ArrowRight";
      var back = k === "ArrowUp" || k === "ArrowLeft";
      if (!fwd && !back) return;
      e.preventDefault();
      var list = plans();
      var i = list.indexOf(p);
      var next = list[(i + (fwd ? 1 : list.length - 1)) % list.length];
      next.focus();
      next.click();
    });
  }
  sheet.setAttribute("data-mode", "sub");

  /* One sheet, opened in different configs (the A/B/C variants reuse it):
       'full'    → both modes, subscription pre-selected (control).
       'sub'     → subscription only; the mode toggle is hidden (variant B main CTA).
       'onetime' → both modes, one-time pre-selected (variant B "Einmaliger Kauf" link).
       'otponly' → one-time only; toggle hidden, no Abo cross-sell (variant C).
     'onetime' and 'otponly' both land in one-time mode; they differ in whether the
     customer can still switch to Abo, so keep them distinct — collapsing them would
     put the subscription toggle back on variant C.
     Config is read from the opener's data-sheet attribute so no opener needs to
     know the sheet internals. emit() makes the pricing engine recompute for the mode. */
  function applyConfig(config) {
    var mode = (config === "onetime" || config === "otponly") ? "onetime" : "sub";
    sheet.classList.toggle("sub-only", config === "sub");
    sheet.classList.toggle("otp-only", config === "otponly");
    sheet.setAttribute("data-mode", mode);
    sheet.dataset.config = config;
    togs.forEach(function (t) { t.classList.toggle("sel", t.getAttribute("data-mode") === mode); });
    emit();
  }
  function openWith(config, opener) {
    applyConfig(config || "full");
    sheet._plOpened = true; sheet._plAdded = false; sheet._plSwitches = 0; sheet._plOpenedAt = Date.now();
    jcTrack("sheet_open", { opener: opener || "unknown", sheet_config: config || "full" });
    show();
  }

  open.addEventListener("click", function () { openWith(open.getAttribute("data-sheet") || "full", "main_cta"); });

  var otp = document.getElementById("plOtp");
  if (otp) otp.addEventListener("click", function (e) {
    e.preventDefault();
    openWith("onetime", "otp_link");
    jcTrack("otp_link_click", { sheet_config: "onetime" });
  });

  // also open the sheet from the sticky bar CTA, in the page's configured mode
  var sticky = document.querySelector(".sticky .btn, .sticky button");
  if (sticky) sticky.addEventListener("click", function (e) { e.preventDefault(); openWith(sticky.getAttribute("data-sheet") || "full", "sticky"); });

  // Secondary CTAs (the <a href="#buy"> links scattered down the page) used to
  // only scroll to the buy box. They should scroll up AND then open the sheet,
  // in the page's configured mode. The main CTA (#plOpen), OTP link and sticky
  // bar are wired above; the sticky bar is fixed so it never scrolls — skip it.
  var buyBox = document.getElementById("buy");
  function scrollThenOpen(cfg, opener) {
    var opened = false;
    function fire() {
      if (opened) return; opened = true;
      window.removeEventListener("scrollend", fire);
      clearTimeout(fallback);
      openWith(cfg, opener);
    }
    var targetY = buyBox ? (window.pageYOffset + buyBox.getBoundingClientRect().top) : 0;
    // Already at the buy box: open immediately, nothing to scroll.
    if (Math.abs(targetY - window.pageYOffset) <= 4) { openWith(cfg, opener); return; }
    // Otherwise open once the smooth scroll settles (scrollend), with a timeout
    // fallback for browsers without scrollend support.
    window.addEventListener("scrollend", fire);
    var fallback = setTimeout(fire, 1000);
    if (buyBox) buyBox.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  }
  [].slice.call(document.querySelectorAll('a[href="#buy"]')).forEach(function (a) {
    if (a.closest(".sticky")) return; // sticky bar has its own opener above
    a.addEventListener("click", function (e) {
      e.preventDefault();
      scrollThenOpen(a.getAttribute("data-sheet") || open.getAttribute("data-sheet") || "full", "secondary_cta");
    });
  });
})();


/* ---- Shopify-authoritative package + subscription engine ------------------
   Liquid emits market-contextual variant and selling-plan allocations. The
   browser formats those integer subunit amounts; it never recreates Shopify's
   percentage/fixed-amount/fixed-price rules or predicts automatic discounts.
--------------------------------------------------------------------------- */
(function () {
  "use strict";
  var root = document.querySelector(".jc-pdp");
  var sheet = document.getElementById("plSheet");
  var group = document.getElementById("plPlans");
  if (!root || !sheet || !group) return;

  var product;
  try { product = JSON.parse(document.getElementById("jc-pdp-plans").textContent); } catch (_) {}
  if (!product || !Array.isArray(product.variants) || !product.variants.length) return;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById("jc-pdp-config").textContent); } catch (_) {}
  var currency = cfg.currency || product.currency || "EUR";
  var locale = cfg.locale || "de-DE";
  var formatter = new Intl.NumberFormat(locale, { style: "currency", currency: currency });
  var analyticsSurface = cfg.analytics_surface === "subscription_alt" ? "subscription_alt" : "subscription_alt";
  var cardTemplate = group.querySelector(".pl-plan").cloneNode(true);
  var assignmentCache = {};
  var activeAssignment = null;
  var presentationCache = {};
  var activePresentation = null;
  var presentationGeneration = 0;
  var assignmentGeneration = 0;
  var atcBusy = false;

  function money(cents) { return formatter.format((Number(cents) || 0) / 100); }
  function percent(reference, actual) { return reference > actual && reference > 0 ? Math.round((1 - actual / reference) * 100) : 0; }
  function perDay(total, days) { return days > 0 ? formatter.format((Number(total) || 0) / 100 / days) : ""; }
  function numericId(value) { var match = String(value == null ? "" : value).match(/(?:^|\/)(\d+)$/); return match ? match[1] : ""; }

  // Package quantity is commerce data, not copy. Accept only explicit plan-ID
  // mappings from the section setting or the product JSON metafield
  // custom.subscription_package_quantities. Human-readable plan names,
  // descriptions and cadence labels are never parsed.
  var packageQuantities = {};
  function registerPackageQuantity(planId, quantity) {
    var id = numericId(planId);
    var parsed = Number(quantity);
    if (!id || !Number.isInteger(parsed) || parsed < 1 || parsed > 50) return;
    packageQuantities[id] = parsed;
  }
  function loadPackageQuantities(source) {
    if (!source) return;
    if (typeof source === "string") {
      var value = source.trim();
      if (!value) return;
      try { loadPackageQuantities(JSON.parse(value)); return; } catch (_) {}
      value.split(/[\n,;]+/).forEach(function (entry) {
        var match = entry.trim().match(/^(?:gid:\/\/shopify\/SellingPlan\/)?(\d+)\s*[:=]\s*(\d+)$/);
        if (match) registerPackageQuantity(match[1], match[2]);
      });
      return;
    }
    if (Array.isArray(source)) {
      source.forEach(function (entry) {
        if (entry && typeof entry === "object") {
          registerPackageQuantity(entry.selling_plan_id || entry.sellingPlanId || entry.plan_id, entry.quantity);
        }
      });
      return;
    }
    if (typeof source === "object") {
      Object.keys(source).forEach(function (planId) { registerPackageQuantity(planId, source[planId]); });
    }
  }
  loadPackageQuantities(cfg.package_quantity_metafield);
  loadPackageQuantities(cfg.package_quantity_map);

  function configuredOption(allocation, quantity) {
    if (!activePresentation) return null;
    var list = allocation ? activePresentation.plans : activePresentation.oneTimeOptions;
    if (!Array.isArray(list)) return null;
    return list.filter(function (option) { return Number(option.quantity) === Number(quantity) && (!allocation || numericId(option.sellingPlanId) === numericId(allocation.plan_id)); })[0] || null;
  }
  function applyPresentation(presentation) {
    if (!presentation) return false;
    (presentation.plans || []).forEach(function (plan) { registerPackageQuantity(plan.sellingPlanId, plan.quantity); });
    var labels = sheet.querySelectorAll(".pl-body > .pl-label");
    if (labels[0] && presentation.pdp && presentation.pdp.weightPickerLabel) labels[0].textContent = presentation.pdp.weightPickerLabel;
    if (labels[1] && presentation.pdp && presentation.pdp.packagePickerLabel) labels[1].textContent = presentation.pdp.packagePickerLabel;
    function setToggleLabel(mode, value) { var button = sheet.querySelector('.pl-tog[data-mode="' + mode + '"]'); if (!button || !value) return; var label = button.querySelector(".pl-tog-label"); if (!label) { label = document.createElement("span"); label.className = "pl-tog-label"; [].slice.call(button.childNodes).forEach(function (node) { if (node.nodeType === 3) node.remove(); }); button.appendChild(label); } label.textContent = value; }
    if (presentation.pdp) { setToggleLabel("sub", presentation.pdp.subscriptionTabLabel); setToggleLabel("onetime", presentation.pdp.oneTimeTabLabel); }
    // Offer availability is authoritative. A subscription-only offer must not
    // leak the Liquid one-time fallback link (or a dead mode toggle) back into
    // the PDP while the signed offer is active.
    var subscriptionConfigured = Array.isArray(presentation.plans);
    var oneTimeConfigured = Array.isArray(presentation.oneTimeOptions);
    var subscriptionAvailable = subscriptionConfigured && presentation.plans.length > 0;
    var oneTimeAvailable = oneTimeConfigured && presentation.oneTimeOptions.length > 0;
    var subscriptionToggle = sheet.querySelector('.pl-tog[data-mode="sub"]');
    var oneTimeToggle = sheet.querySelector('.pl-tog[data-mode="onetime"]');
    var oneTimeEntry = document.getElementById("plOtp");
    if (subscriptionConfigured && subscriptionToggle) subscriptionToggle.hidden = !subscriptionAvailable;
    if (oneTimeConfigured && oneTimeToggle) oneTimeToggle.hidden = !oneTimeAvailable;
    if (oneTimeConfigured && oneTimeEntry) oneTimeEntry.hidden = !oneTimeAvailable;
    sheet.classList.toggle("offer-sub-only", subscriptionConfigured && subscriptionAvailable && oneTimeConfigured && !oneTimeAvailable);
    sheet.classList.toggle("offer-otp-only", oneTimeConfigured && oneTimeAvailable && subscriptionConfigured && !subscriptionAvailable);
    sheet.dataset.offerModes = subscriptionAvailable ? (oneTimeAvailable ? "both" : "sub") : (oneTimeAvailable ? "onetime" : "none");
    if ((!oneTimeAvailable && isOneTime()) || (!subscriptionAvailable && !isOneTime() && oneTimeAvailable)) {
      var nextMode = subscriptionAvailable ? "sub" : "onetime";
      sheet.setAttribute("data-mode", nextMode);
      [].slice.call(sheet.querySelectorAll(".pl-tog")).forEach(function (toggle) {
        toggle.classList.toggle("sel", toggle.getAttribute("data-mode") === nextMode);
      });
    }
    var secure = sheet.querySelector(".pl-secure span"); if (secure && presentation.pdp && presentation.pdp.securePaymentMessage) secure.textContent = presentation.pdp.securePaymentMessage;
    var automatic = sheet.querySelector(".pl-auto"); if (automatic && presentation.pdp && presentation.pdp.discountMessage) automatic.textContent = "✓ " + presentation.pdp.discountMessage;
    var defaultButton = null;
    (presentation.variantChoices || []).forEach(function (choice) { var button = sheet.querySelector('.pl-size[data-variant-id="' + numericId(choice.productVariantId) + '"]'); if (!button) return; var label = button.querySelector("span:not(.pl-size-price):not(.pl-size-badge)"); if (label && choice.displayLabel) label.textContent = choice.displayLabel; var badge = button.querySelector(".pl-size-badge"); if (choice.badgeText) { if (!badge) { badge = document.createElement("small"); badge.className = "pl-size-badge"; button.appendChild(badge); } badge.textContent = choice.badgeText; } else if (badge) badge.remove(); if (choice.defaultSelected) defaultButton = button; });
    if (defaultButton && !sheet.dataset.variantSelection && !sheet.dataset.appDefaultApplied) { sheet.dataset.appDefaultApplied = "true"; var changed = !defaultButton.classList.contains("sel"); [].slice.call(sheet.querySelectorAll(".pl-size")).forEach(function (button) { button.classList.toggle("sel", button === defaultButton); }); return changed; }
    return false;
  }
  function loadPresentation() { var variant = currentVariant(); if (!window.JCCheckout || !JCCheckout.requestCommercePresentation) return Promise.resolve(null); var key = String(variant.id) + ":" + String(cfg.country || "DE"); var generation = ++presentationGeneration; if (!presentationCache[key]) presentationCache[key] = JCCheckout.requestCommercePresentation({ variantId: variant.id, countryCode: cfg.country || "DE" }).catch(function () { return null; }); return presentationCache[key].then(function (presentation) { if (generation !== presentationGeneration) return null; activePresentation = presentation; if (applyPresentation(presentation)) return loadPresentation(); return presentation; }); }

  function variantForKey(key) {
    key = String(key || "").toLowerCase().replace(/\s+/g, "");
    for (var i = 0; i < product.variants.length; i++) {
      var title = String(product.variants[i].title || "").toLowerCase().replace(/\s+/g, "");
      if (key && title.indexOf(key) !== -1) return product.variants[i];
    }
    return product.variants.filter(function (variant) { return variant.available; })[0] || product.variants[0];
  }

  function variantForButton(button) {
    var id = numericId(button && button.getAttribute("data-variant-id"));
    if (id) {
      var exact = product.variants.filter(function (variant) { return numericId(variant.id) === id; })[0];
      if (exact) return exact;
    }
    return variantForKey(button && button.getAttribute("data-key"));
  }

  function currentVariant() {
    var selected = sheet.querySelector(".pl-size.sel");
    return variantForButton(selected);
  }

  function recurringAllocations(variant) {
    return (variant.allocations || []).filter(function (allocation) {
      return allocation.recurring !== false && numericId(allocation.plan_id);
    });
  }

  function quantityFor(allocation) {
    return packageQuantities[numericId(allocation && allocation.plan_id)] || 0;
  }

  function allocationById(variant, id) {
    id = numericId(id);
    return recurringAllocations(variant).filter(function (allocation) {
      return numericId(allocation.plan_id) === id && quantityFor(allocation) > 0;
    })[0] || null;
  }

  function phasePrices(allocation) {
    var adjustments = (allocation.adjustments || []).slice().sort(function (a, b) { return Number(a.position) - Number(b.position); });
    var first = adjustments[0] ? Number(adjustments[0].price) : Number(allocation.price);
    var renewal = first;
    var firstCycles = null;
    if (adjustments[0] && adjustments[0].order_count != null) firstCycles = Number(adjustments[0].order_count);
    if (adjustments[1]) renewal = Number(adjustments[1].price);
    else if (firstCycles && Number(allocation.compare_at) > 0) renewal = Number(allocation.compare_at);
    return { first: first, renewal: renewal, firstCycles: firstCycles };
  }

  function figure(variant, quantity, allocation) {
    quantity = Math.max(1, Number(quantity) || 1);
    var configured = configuredOption(allocation, quantity);
    if (!allocation) {
      if (configured && configured.price) return { total: Number(configured.price.amount), renewalTotal: Number(configured.price.amount), reference: Number(configured.price.catalogUnitAmount) * quantity, renewalReference: Number(configured.price.catalogUnitAmount) * quantity, checkoutTotal: Number(configured.price.amount), quantity: quantity, days: quantity * 28, planId: "", allocation: null };
      var oneTime = Number(variant.price) * quantity;
      var oneTimeReference = Number(variant.compare_at || 0) * quantity;
      return {
        total: oneTime,
        renewalTotal: oneTime,
        reference: oneTimeReference > oneTime ? oneTimeReference : 0,
        renewalReference: oneTimeReference > oneTime ? oneTimeReference : 0,
        checkoutTotal: oneTime,
        quantity: quantity,
        days: quantity * 28,
        planId: "",
        allocation: null
      };
    }
    if (configured && configured.first && configured.renewal) return { total: Number(configured.first.amount), renewalTotal: Number(configured.renewal.amount), reference: Number(configured.first.catalogUnitAmount) * quantity, renewalReference: Number(configured.renewal.catalogUnitAmount) * quantity, checkoutTotal: Number(configured.first.amount), quantity: quantity, days: quantity * 28, planId: numericId(allocation.plan_id), allocation: allocation, firstCycles: Number(configured.first.unitAmount) === Number(configured.renewal.unitAmount) ? 0 : 1 };
    var commerce = activeAssignment && activeAssignment.commerceOffer;
    if (commerce && commerce.subscription && String(numericId(commerce.productVariantId)) === String(variant.id) &&
        Number(commerce.quantity) === quantity && numericId(commerce.sellingPlanId) === numericId(allocation.plan_id)) {
      var first = commerce.subscription.first;
      var renewal = commerce.subscription.renewal;
      return {
        total: Number(first.amount),
        renewalTotal: Number(renewal.amount),
        reference: Number(first.catalogUnitAmount) * quantity,
        renewalReference: Number(renewal.catalogUnitAmount) * quantity,
        checkoutTotal: Number(first.amount),
        quantity: quantity,
        days: quantity * 28,
        planId: numericId(allocation.plan_id),
        allocation: allocation,
        firstCycles: Number(first.unitAmount) === Number(renewal.unitAmount) ? 0 : 1
      };
    }
    var phases = phasePrices(allocation);
    var reference = Number(allocation.compare_at || 0) * quantity;
    var firstTotal = phases.first * quantity;
    var renewalTotal = phases.renewal * quantity;
    var checkoutUnit = allocation.checkout_charge == null ? phases.first : Number(allocation.checkout_charge);
    if (!Number.isFinite(checkoutUnit)) checkoutUnit = phases.first;
    return {
      total: firstTotal,
      renewalTotal: renewalTotal,
      reference: reference > firstTotal ? reference : 0,
      renewalReference: reference > renewalTotal ? reference : 0,
      checkoutTotal: checkoutUnit * quantity,
      quantity: quantity,
      days: quantity * 28,
      planId: numericId(allocation.plan_id),
      allocation: allocation,
      firstCycles: phases.firstCycles
    };
  }

  function isOneTime() { return sheet.getAttribute("data-mode") === "onetime"; }

  function selectedCard() { return group.querySelector(".pl-plan.sel") || group.querySelector(".pl-plan"); }
  function selectedFigure() {
    var card = selectedCard();
    var variant = currentVariant();
    if (!card) return figure(variant, 1, null);
    var allocation = allocationById(variant, card.getAttribute("data-plan-id"));
    return figure(variant, card.getAttribute("data-qty"), allocation);
  }

  function setCard(card, variant, allocation, quantity) {
    var value = figure(variant, quantity, allocation);
    var configured = configuredOption(allocation, quantity);
    card.dataset.qty = String(quantity);
    card.dataset.planId = value.planId;
    card.dataset.selectionKey = value.planId ? "sub:" + value.planId : "one:" + quantity;
    card.removeAttribute("data-plan-missing");

    var name = card.querySelector(".pl-plan-name");
    name.textContent = configured && configured.displayLabel || quantity + (quantity === 1 ? " Dose" : " Dosen");
    var sub = card.querySelector(".pl-plan-sub");
    sub.textContent = configured && configured.subtitle ? configured.subtitle : allocation
      ? (allocation.name || "Auto-Lieferung") + (value.days ? " · " + perDay(value.total, value.days) + " pro Tag" : "")
      : (quantity === 1 ? "1 Monatsvorrat" : quantity + " Monatsvorräte") + " · " + perDay(value.total, value.days) + " pro Tag";

    var phase = card.querySelector(".pl-price-phase");
    if (!phase) {
      phase = document.createElement("span");
      phase.className = "pl-price-phase";
      card.querySelector(".pl-plan-main").appendChild(phase);
    }
    if (allocation && value.renewalTotal !== value.total) {
      phase.textContent = "Zuerst " + money(value.total) + (value.firstCycles ? " für " + value.firstCycles + (value.firstCycles === 1 ? " Lieferung" : " Lieferungen") : "") + ", danach " + money(value.renewalTotal);
      phase.hidden = false;
    } else if (allocation) {
      phase.textContent = money(value.renewalTotal) + " je Lieferung";
      phase.hidden = false;
    } else {
      phase.hidden = true;
    }

    card.querySelector(".pl-now").textContent = money(value.checkoutTotal);
    var was = card.querySelector(".pl-was");
    var saving = percent(value.reference, value.total);
    was.textContent = saving ? money(value.reference) : "";
    was.hidden = !saving;
    var badge = card.querySelector(".pl-badge");
    badge.textContent = saving ? "SPARE " + saving + "%" : "";
    badge.hidden = !badge.textContent;
    var alt = card.querySelector(".pl-badge-alt");
    if (alt) { alt.textContent = configured && configured.badgeText || ""; alt.hidden = !alt.textContent; }
    var best = card.querySelector(".pl-best");
    if (best) best.hidden = true;
    var perks = card.querySelector(".pl-perks");
    if (perks) { var items = configured && Array.isArray(configured.bullets) ? configured.bullets : []; perks.replaceChildren(); items.forEach(function (item) { var li = document.createElement("li"); li.textContent = item; perks.appendChild(li); }); perks.hidden = !items.length; }
  }

  function buildCards() {
    var variant = currentVariant();
    var oneTime = isOneTime();
    var previous = selectedCard();
    var previousKey = previous ? previous.dataset.selectionKey : "";
    var desiredPlan = activeAssignment && String(activeAssignment.variantId) === String(variant.id)
      ? numericId(activeAssignment.selectedSellingPlanId) : "";
    var configuredSpecs = activePresentation && oneTime ? activePresentation.oneTimeOptions : null;
    var configuredPlans = activePresentation && !oneTime ? activePresentation.plans : null;
    var specs = oneTime
      ? (Array.isArray(configuredSpecs) && configuredSpecs.length ? configuredSpecs.map(function (option) { return { quantity: option.quantity, allocation: null }; }) : [{ quantity: 1, allocation: null }, { quantity: 3, allocation: null }])
      : recurringAllocations(variant).filter(function (allocation) { return !Array.isArray(configuredPlans) || configuredPlans.some(function (plan) { return numericId(plan.sellingPlanId) === numericId(allocation.plan_id); }); }).map(function (allocation) {
          return { quantity: quantityFor(allocation), allocation: allocation };
        }).filter(function (spec) { return spec.quantity > 0; });

    group.replaceChildren();
    if (!specs.length) {
      var unavailable = cardTemplate.cloneNode(true);
      setCard(unavailable, variant, null, 1);
      unavailable.dataset.planMissing = "1";
      unavailable.querySelector(".pl-plan-name").textContent = "Abo-Konfiguration fehlt";
      unavailable.querySelector(".pl-plan-sub").textContent = "Für diesen Shopify Selling Plan ist keine sichere Paketmenge hinterlegt.";
      group.appendChild(unavailable);
    } else {
      specs.forEach(function (spec) {
        var card = cardTemplate.cloneNode(true);
        card.classList.remove("sel");
        setCard(card, variant, spec.allocation, spec.quantity);
        group.appendChild(card);
      });
    }

    var cards = [].slice.call(group.querySelectorAll(".pl-plan"));
    var configuredDefault = (Array.isArray(oneTime ? configuredSpecs : configuredPlans) ? (oneTime ? configuredSpecs : configuredPlans) : []).filter(function (option) { return option.defaultSelected; })[0];
    var configuredDefaultKey = configuredDefault ? (oneTime ? "one:" + configuredDefault.quantity : "sub:" + numericId(configuredDefault.sellingPlanId)) : "";
    var selected = cards.filter(function (card) {
      return desiredPlan && card.dataset.planId === desiredPlan;
    })[0] || cards.filter(function (card) { return card.dataset.selectionKey === previousKey; })[0] || cards.filter(function (card) { return card.dataset.selectionKey === configuredDefaultKey; })[0];
    if (!selected) selected = cards[cards.length > 1 ? cards.length - 1 : 0];
    if (selected) selected.classList.add("sel");
    if (sheet.plSyncPlans) sheet.plSyncPlans();
  }

  function updateSizePrices() {
    [].slice.call(sheet.querySelectorAll(".pl-size")).forEach(function (button) {
      var variant = variantForButton(button);
      var price = button.querySelector(".pl-size-price");
      if (!price) {
        price = document.createElement("span");
        price.className = "pl-size-price";
        button.appendChild(price);
      }
      if (isOneTime()) {
        price.textContent = money(variant.price);
        return;
      }
      var figures = recurringAllocations(variant).map(function (allocation) {
        var quantity = quantityFor(allocation);
        return quantity > 0 ? figure(variant, quantity, allocation) : null;
      }).filter(Boolean).sort(function (a, b) { return a.total - b.total; });
      if (!figures.length) {
        price.textContent = variant.available ? "Abo-Konfiguration fehlt" : "Ausverkauft";
      } else {
        var best = figures[0];
        price.textContent = best.renewalTotal !== best.total
          ? money(best.total) + " → " + money(best.renewalTotal)
          : "ab " + money(best.total);
      }
    });
  }

  function assignmentKey(variantId, planId, quantity) {
    return String(variantId) + ":" + String(planId) + ":" + String(quantity) + ":" + String(cfg.country || "DE");
  }
  function requestAssignment() {
    var current = selectedFigure();
    var variant = currentVariant();
    if (isOneTime() || !current.planId || !window.JCCheckout || !JCCheckout.requestOfferAssignment) return Promise.resolve(null);
    if (activeAssignment && String(activeAssignment.variantId) === String(variant.id) &&
        Number(activeAssignment.quantity) === Number(current.quantity) &&
        (numericId(activeAssignment.entrySellingPlanId) === current.planId || numericId(activeAssignment.selectedSellingPlanId) === current.planId)) {
      return Promise.resolve(activeAssignment);
    }
    var key = assignmentKey(variant.id, current.planId, current.quantity);
    var generation = ++assignmentGeneration;
    if (!assignmentCache[key]) {
      assignmentCache[key] = JCCheckout.requestCommerceOffer({
        variantId: variant.id,
        sellingPlanId: current.planId,
        quantity: current.quantity,
        countryCode: cfg.country || "DE"
      }).then(function (commerceOffer) {
        if (commerceOffer && commerceOffer.subscription && numericId(commerceOffer.sellingPlanId)) return { commerceOffer: commerceOffer };
        return JCCheckout.requestOfferAssignment({
        variantId: variant.id,
        entrySellingPlanId: current.planId,
        quantity: current.quantity,
        countryCode: cfg.country || "DE"
        });
      }).catch(function () { return null; });
    }
    return assignmentCache[key].then(function (result) {
      if (!result || generation !== assignmentGeneration) return null;
      var selectedId = numericId(result.commerceOffer && result.commerceOffer.sellingPlanId || result.selectedSellingPlanNumericId || result.selectedSellingPlanId);
      var selectedAllocation = allocationById(variant, selectedId);
      // Experiments may choose another allowlisted Shopify plan, but never a
      // different package quantity. Quantity is commerce state, not an
      // analytics variant.
      if (!selectedAllocation || quantityFor(selectedAllocation) !== Number(current.quantity)) return null;
      activeAssignment = {
        variantId: variant.id,
        quantity: current.quantity,
        entrySellingPlanId: current.planId,
        selectedSellingPlanId: selectedId,
        assignmentToken: result.assignmentToken,
        commerceOfferToken: result.commerceOffer && result.commerceOffer.offerToken || "",
        commerceOffer: result.commerceOffer || null,
        experiment: result.commerceOffer && result.commerceOffer.experiment ? { key: result.commerceOffer.experiment.key, variant: result.commerceOffer.experiment.variant, assignmentId: "commerce:" + result.commerceOffer.offerId } : result.experiment || null
      };
      buildCards();
      updateSummary();
      return activeAssignment;
    });
  }

  function updateSummary() {
    updateSizePrices();
    buildCards();
    var value = selectedFigure();
    var selectedVariant = currentVariant();
    var selectionUnavailable = !selectedVariant.available || (!isOneTime() && !value.planId);
    var hint = document.getElementById("plHint");
    if (hint) {
      if (isOneTime() && !sheet.classList.contains("otp-only")) {
        var variant = currentVariant();
        var allocation = recurringAllocations(variant).filter(function (candidate) { return quantityFor(candidate) > 0; })[0];
        var subscription = allocation ? figure(variant, quantityFor(allocation), allocation) : null;
        var saving = subscription && value.quantity === subscription.quantity ? value.total - subscription.total : 0;
        hint.textContent = saving > 0 ? "Mit Auto-Lieferung sparst du " + money(saving) + "." : "Im Warenkorb werden verfügbare Shopify-Rabatte automatisch berechnet.";
        hint.style.display = "";
      } else if (sheet.classList.contains("otp-only")) {
        hint.style.display = "none";
      } else if (selectionUnavailable) {
        hint.textContent = selectedVariant.available
          ? "Dieser Lieferplan ist noch nicht mit einer sicheren Paketmenge konfiguriert."
          : "Diese Variante ist derzeit ausverkauft.";
        hint.style.display = "";
      } else {
        hint.textContent = value.checkoutTotal === 0
          ? "Produktpreis heute " + money(0) + "; Versand und Steuern werden im Checkout berechnet."
          : value.renewalTotal !== value.total
          ? "Einführungspreis " + money(value.total) + ", danach " + money(value.renewalTotal) + " je Lieferung."
          : "Preis und Lieferintervall kommen direkt aus deinem Shopify-Abo.";
        hint.style.display = "";
      }
    }
    var text = document.getElementById("plAtcTxt");
    var summaryAtc = document.getElementById("plAtc");
    if (summaryAtc) {
      summaryAtc.disabled = selectionUnavailable;
      summaryAtc.setAttribute("aria-disabled", selectionUnavailable ? "true" : "false");
    }
    var addToCartLabel = activePresentation && activePresentation.pdp && activePresentation.pdp.addToCartLabel || "In den Warenkorb";
    if (text) text.textContent = !selectedVariant.available
      ? "Ausverkauft"
      : selectionUnavailable
      ? "Abo-Konfiguration fehlt"
      : addToCartLabel + " | " + (value.checkoutTotal === 0 ? "Produktpreis " : "") + money(value.checkoutTotal);
    var otp = document.getElementById("plOtpPrice");
    if (otp) otp.textContent = money(figure(currentVariant(), 1, null).total);
    var offer = document.getElementById("plOfferLine");
    if (offer) {
      var savingPct = percent(value.reference, value.total);
      offer.textContent = !isOneTime() && savingPct > 0
        ? savingPct + "% günstiger in der ersten Abo-Lieferung"
        : (!isOneTime() ? "Flexible Auto-Lieferung · Preisdetails im Paket" : "Preis und Rabatte werden von Shopify berechnet");
    }
    var stickyPrice = document.getElementById("stickyPrice");
    var stickyDay = document.getElementById("stickyDay");
    if (stickyPrice) stickyPrice.textContent = money(value.checkoutTotal);
    if (stickyDay) stickyDay.textContent = value.days ? "· " + perDay(value.total, value.days) + "/Tag" : "";
    if (!isOneTime()) requestAssignment();
  }

  sheet.addEventListener("pl:change", function () {
    activeAssignment = null;
    assignmentGeneration++;
    loadPresentation().then(updateSummary);
  });
  loadPresentation().then(updateSummary);

  var atc = document.getElementById("plAtc");
  if (!atc) return;
  var atcErr = null;
  function showError(message) {
    if (!atcErr) {
      atcErr = document.createElement("p");
      atcErr.className = "pl-err";
      atcErr.setAttribute("role", "alert");
      atc.parentNode.insertBefore(atcErr, atc);
    }
    atcErr.textContent = message;
    atcErr.hidden = false;
  }
  sheet.addEventListener("pl:change", function () { if (atcErr) atcErr.hidden = true; });

  function dispatchCartUpdate(promise) {
    var event = new Event("shopify:cart:lines-update", { bubbles: true });
    Object.defineProperty(event, "action", { value: "add" });
    Object.defineProperty(event, "promise", { value: promise });
    root.dispatchEvent(event);
  }

  function knownCartCount() {
    try {
      var stored = JSON.parse(sessionStorage.getItem("cart-count") || "null");
      if (stored && Number.isFinite(Number(stored.value))) return Math.max(0, Number(stored.value));
    } catch (_) {}
    var count = document.querySelector('[ref="cartBubbleCount"]');
    return count && Number.isFinite(Number(count.textContent)) ? Math.max(0, Number(count.textContent)) : 0;
  }

  function prepareCustomCheckoutCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("Der Warenkorb konnte nicht vorbereitet werden.");
      return response.json();
    }).then(function (cart) {
      if (!cart.items || !cart.items.length) return cart;
      // This PDP is an isolated direct-response funnel. A signed App offer must
      // be the only Shopify transport line, otherwise previous native-PDP items
      // can change the quantity, price and checkout destination.
      return fetch("/cart/clear.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({})
      }).then(function (response) {
        if (!response.ok) throw new Error("Der Warenkorb konnte nicht für das Angebot vorbereitet werden.");
        return response.json();
      });
    });
  }

  function addSelected() {
    var variant = currentVariant();
    var selected = selectedFigure();
    if (!variant.available) throw new Error("Diese Variante ist aktuell ausverkauft.");
    if (!isOneTime() && !selected.planId) throw new Error("Dieses Abo ist gerade nicht verfügbar. Bitte wähle Einmalkauf.");
    var metaEventId = null;
    try {
      if (window.JCMetaPixel && window.JCMetaPixel.createEventId) metaEventId = window.JCMetaPixel.createEventId("addtocart");
    } catch (_) {}

    var item = { id: Number(variant.id), quantity: selected.quantity };
    if (selected.planId) item.selling_plan = Number(selected.planId);
    var experiment = activeAssignment && activeAssignment.experiment;
    var previousCartCount = knownCartCount();
    item.properties = {
      _knuffel_entry_selling_plan: activeAssignment && activeAssignment.entrySellingPlanId || selected.planId || "",
      _knuffel_pdp_surface: analyticsSurface
    };
    if (selected.planId) {
      item.properties._knuffel_subscription_quantity = String(selected.quantity);
      item.properties._knuffel_subscription_first_amount = String(selected.checkoutTotal);
      item.properties._knuffel_subscription_renewal_amount = String(selected.renewalTotal);
      item.properties._knuffel_subscription_catalog_amount = String(selected.reference || 0);
      item.properties._knuffel_subscription_interval_days = String(selected.days || 28);
    }
    if (activeAssignment && activeAssignment.assignmentToken) {
      Object.assign(item.properties, {
        _knuffel_experiment_assignment: activeAssignment.assignmentToken,
        _knuffel_experiment_key: experiment && experiment.key || "",
        _knuffel_experiment_variant: experiment && experiment.variant || "",
        _knuffel_experiment_assignment_id: experiment && experiment.assignmentId || ""
      });
    }
    if (activeAssignment && activeAssignment.commerceOfferToken) {
      var commerceOffer = activeAssignment.commerceOffer;
      var commerceOption = commerceOffer && commerceOffer.presentation && commerceOffer.presentation.option;
      var commerceFirst = commerceOffer && commerceOffer.subscription && commerceOffer.subscription.first;
      var commerceRenewal = commerceOffer && commerceOffer.subscription && commerceOffer.subscription.renewal;
      item.properties._knuffel_commerce_offer_token = activeAssignment.commerceOfferToken;
      item.properties._knuffel_commerce_offer_id = commerceOffer && commerceOffer.offerId || "";
      item.properties._knuffel_commerce_offer_code = commerceOffer && commerceOffer.code || "";
      item.properties._knuffel_commerce_offer_name = commerceOffer && commerceOffer.name || "";
      item.properties._knuffel_commerce_currency = commerceOffer && commerceOffer.currency || currency;
      item.properties._knuffel_commerce_quantity = String(selected.quantity);
      item.properties._knuffel_commerce_first_amount = commerceFirst ? String(commerceFirst.amount) : "";
      item.properties._knuffel_commerce_first_catalog_amount = commerceFirst ? String(Number(commerceFirst.catalogUnitAmount) * selected.quantity) : "";
      item.properties._knuffel_commerce_renewal_amount = commerceRenewal ? String(commerceRenewal.amount) : "";
      item.properties._knuffel_commerce_renewal_catalog_amount = commerceRenewal ? String(Number(commerceRenewal.catalogUnitAmount) * selected.quantity) : "";
      item.properties._knuffel_commerce_paid_quantity = commerceOption ? String(commerceOption.paidQuantity || selected.quantity) : String(selected.quantity);
      item.properties._knuffel_commerce_free_quantity = commerceOption ? String(commerceOption.freeQuantity || 0) : "0";
    }

    var addController = new AbortController();
    var timeout = setTimeout(function () { addController.abort(); }, 8000);
    var prepareCart = selected.planId ? prepareCustomCheckoutCart() : Promise.resolve(null);
    var updatePromise = prepareCart.then(function (preparedCart) {
      if (preparedCart) previousCartCount = Number(preparedCart.item_count) || 0;
      return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      signal: addController.signal,
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [item], sections: ["cart-drawer-section"], sections_url: location.pathname })
      });
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok || body.status) throw new Error(body.description || body.message || "Der Warenkorb konnte nicht aktualisiert werden.");
        return body;
      });
    }).then(function (response) {
      var JC_VER = { sub_first: "Sub-first (B)", otp_only: "OTP-only (C)" };
      var presentation = window.JC_PDP_CHECKOUT_VARIANT || "control";
      return Promise.all([
        Promise.resolve(response),
        fetch("/cart/update.js", {
          method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ attributes: { "_PDP-Version": JC_VER[presentation] || "Control (A)", "PDP-Version": "", _ph_variant: presentation } })
        }).then(function (r) {
          if (!r.ok) throw new Error("cart/update.js " + r.status);
          return r.json();
        }).catch(function () {
          // Attribute persistence is best-effort. If it fails after add.js has
          // already committed the line, fetch the cart instead of surfacing a
          // false add error that could lead to a duplicate retry.
          return fetch("/cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } })
            .then(function (r) { if (!r.ok) throw new Error("cart.js " + r.status); return r.json(); })
            .catch(function () { return null; });
        })
      ]);
    }).then(function (result) {
      var response = result[0], cart = result[1];
      var itemCount = cart ? Number(cart.item_count) || 0 : previousCartCount + selected.quantity;
      sheet._plAdded = true;
      var props = {
        variant_id: variant.id,
        quantity: selected.quantity,
        subscription: !!selected.planId,
        selling_plan: selected.planId || null,
        currency: currency,
        value: selected.checkoutTotal / 100,
        renewal_value: selected.renewalTotal / 100,
        pdp_variant: window.JC_PDP_CHECKOUT_VARIANT || "control",
        offer_experiment: experiment && experiment.key || null,
        offer_variant: experiment && experiment.variant || null,
        pdp_surface: analyticsSurface
      };
      // This is the authoritative post-success AddToCart owner for the custom
      // PDP. The marker prevents the standard cart event bridge from emitting a
      // second PostHog conversion for the same accepted Shopify line.
      window.__jcPostHogLastAuthoritativeAddToCartAt = Date.now();
      try { if (window.posthog && posthog.capture) posthog.capture("add_to_cart", props); } catch (_) {}
      try {
        if (window.JCMetaPixel && window.JCMetaPixel.trackAddToCart) {
          window.JCMetaPixel.trackAddToCart({
            content_ids: [String(variant.id)],
            content_name: cfg.handle || variant.title || "Knuffel",
            content_type: "product",
            contents: [{ id: String(variant.id), quantity: selected.quantity }],
            currency: currency,
            value: selected.checkoutTotal / 100,
            subscription: !!selected.planId,
            selling_plan: selected.planId || null
          }, metaEventId);
        }
      } catch (_) {}
      if (sheet.plHide) sheet.plHide();
      return {
        cart: { totalQuantity: itemCount },
        detail: { sections: response.sections || {}, items: cart && cart.items || response.items || [], itemCount: itemCount, source: "jc-pdp", didError: false }
      };
    }).finally(function () { clearTimeout(timeout); });
    return updatePromise.then(function (payload) {
      // The alternate PDP is a direct-response checkout surface: once Shopify
      // has accepted the signed subscription line, continue immediately to the
      // custom checkout instead of making the customer open the cart drawer and
      // click a second button. The bridge preserves Shopify Checkout as the
      // retryable error handling for a handoff outage; it never opens a native
      // Shopify checkout whose price could differ from the signed App offer.
      if (selected.planId && window.JCCheckout && typeof window.JCCheckout.redirectCartToCheckout === "function") {
        return window.JCCheckout.redirectCartToCheckout().then(function () { return payload; });
      }
      // One-time purchases and pages where the bridge was blocked still retain
      // the ordinary Shopify cart behaviour.
      dispatchCartUpdate(Promise.resolve(payload));
      if (!document.getElementById("cart-drawer")) location.assign("/cart");
      return payload;
    });
  }

  atc.addEventListener("click", function () {
    if (atcBusy) return;
    atcBusy = true;
    atc.disabled = true;
    if (atcErr) atcErr.hidden = true;
    var pending = (!isOneTime() && !activeAssignment) ? requestAssignment() : Promise.resolve(activeAssignment);
    Promise.race([pending, new Promise(function (resolve) { setTimeout(function () { resolve(null); }, 650); })])
      .then(function () {
        // Freeze the offer at the moment we add. A slower experiment response may
        // be useful on the next interaction, but must not relabel an in-flight line.
        assignmentGeneration++;
        return addSelected();
      })
      .catch(function (error) {
        showError(error && error.name === "AbortError" ? "Die Verbindung dauert zu lange. Bitte versuche es erneut." : String(error && error.message || error));
        try { if (window.posthog && posthog.capture) posthog.capture("add_to_cart_error", { reason: error && error.name || "request_failed", message: String(error && error.message || error) }); } catch (_) {}
      })
      .finally(function () { atcBusy = false; atc.disabled = false; });
  });
})();

/* Before/after videos: browsers often ignore the autoplay attribute for media
   below the fold. Play when scrolled into view (retrying silently if blocked)
   and pause off-screen to save battery. */
(function () {
  var vids = document.querySelectorAll(".qcard video");
  if (!vids.length) return;
  function tryPlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) tryPlay(e.target);
        else e.target.pause();
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  } else {
    vids.forEach(function (v) { v.muted = true; tryPlay(v); });
  }
})();
